<template>
    <div v-if="config.show != 0"
        style="position: fixed;left: 0;top:0;z-index: 10000;background-color: rgba(0,0,0,0.1);width: 100vw;height: 100vh;transition: background-color, backdrop-filter .3s cubic-bezier(0.1,0.9,0.2,1);display: flex;align-items: center;justify-content: center;"
        :style="{
            backgroundColor: config.show <= 1 ? 'rgba(0,0,0,0)' : 'rgba(0,0,0,0.2)',
            backdropFilter: config.show <= 1 ? 'blur(0px)' : 'blur(40px)'
        }">
        <div @click="config.control(false)"
            style="width: 100%;height: 100%;position: absolute;left: 0;top: 0;background-size: 0.1;opacity: 0.3;"
            :style="{
                backgroundImage: `url(${images.noise})`
            }">

        </div>
        <div :style="{
            opacity: config.show <= 1 ? '0' : '1',
            scale: config.show <= 1 ? '1.1' : '1',
            zoom: zoom,
        }"
            style="display: inline-block;transition-property: opacity, scale;transition-duration: .3s; transition-timing-function: cubic-bezier(0.1,0.9,0.2,1);width: 800px;height: 640px;">
            <div
                style="width: 100%;height: 100%;display: flex;flex-direction: column;align-items: center;justify-content: flex-start;position: relative;">
                <div @click="config.control(false)"
                    style="width: 100%;height: 60px;display: flex;align-items: center;justify-content: center;font-size: 22px;color: white;font-family: 微软雅黑;text-shadow: 0 1px 5px rgba(0,0,0,0.9);position: relative;z-index: 10010;">
                    {{ config.title }}
                </div>
                <div @click="config.control(false)" style="width: 100%;height: 100%;position: absolute;left: 0;top: 0;">

                </div>
                <div
                    style="width: 100%;height: 520px;display: flex;align-items: center;justify-content: center;gap: 24px;position: relative;z-index: 10010;">
                    <div
                        style="width: 100%;height: 100%;background-color: #fff;border-radius: 16px;box-shadow: 0 4px 10px rgba(0,0,0,0.1);display: flex;flex-direction: column;overflow: hidden;">
                        <div
                            style="width: 100%;height: 80px;display: flex;align-items: center;justify-content: center;background-color: #27cd83;color: white;font-size: 28px;font-family: almm;font-weight: 700;text-shadow: 0 2px 5px rgba(0,0,0,0.3);">
                            顺序练习
                        </div>
                        <div style="width: 100%;height: 340px;padding: 25px 40px;">
                            <div style="font-size: 19px;font-weight: bold;position: relative;display: inline-block;">
                                什么是三力测试？
                                <div
                                    style="font-size: 19px;width: 4em;background: linear-gradient(90deg, #3ab680,transparent);height: 0.8em;position: absolute;left: 0;bottom: 0;transform: translateY(40%);display: inline-block">

                                </div>
                            </div>

                            <div style="margin-top: 20px;display: inline-block;font-size: 17px;line-height: 1.5;">
                                “三力”测试包含涉及安全驾驶的<span style="color: #d47d43;">记忆力</span>、<span
                                    style="color: #d47d43;">判断力</span>、<span style="color: #d47d43;">反应力</span>测试。</div>

                            <div
                                style="font-size: 19px;font-weight: bold;position: relative;display: inline-block;margin-top: 20px;">
                                哪些人需要参加三力测试？
                                <div
                                    style="font-size: 19px;width: 4em;background: linear-gradient(90deg, #3ab680,transparent);height: 0.8em;position: absolute;left: 0;bottom: 0;transform: translateY(40%);display: inline-block">

                                </div>
                            </div>

                            <div style="margin-top: 20px;display: inline-block;font-size: 14px;line-height: 1.5;">
                                1、年满<span
                                    style="color: #d47d43;">70周岁以上</span>，申请小型汽车、小型自动挡汽车、残疾人专用小型自动挡载客汽车、轻便摩托车准驾车型驾驶证的；
                            </div>

                            <div style="margin-top: 10px;display: inline-block;font-size: 14px;line-height: 1.5;">
                                2、年龄在<span style="color: #d47d43;">60周岁以上、70周岁以下</span>，申请增加轻型牵引挂车、普通二轮摩托车、普通二轮摩托车准驾车型的。
                            </div>
                        </div>
                        <div
                            style="width: 100%;height: 80px;display: flex;align-items: center;justify-content: center;">
                            <yButton @click="handleClick(1)" border-radius="200px" mask-color="white" color="white"
                                background-color="#5dbf84" font-size="22px" padding="16px 110px">
                                开始练习</yButton>

                        </div>
                    </div>
                    <div
                        style="width: 100%;height: 100%;background-color: #fff;border-radius: 16px;box-shadow: 0 4px 10px rgba(0,0,0,0.1);display: flex;flex-direction: column;overflow: hidden;">
                        <div
                            style="width: 100%;height: 80px;display: flex;align-items: center;justify-content: center;background-color: #5191fe;color: white;font-size: 28px;font-family: almm;font-weight: 700;text-shadow: 0 2px 5px rgba(0,0,0,0.3);">
                            模拟考试
                        </div>
                        <div style="width: 100%;height: 340px;padding: 25px 40px;">
                            <div
                                style="width: 100%;height: 100%;display: flex;flex-direction: column;align-items: flex-start;justify-content: flex-start;gap: 24px;">
                                <div style="width: 100%;font-size: 20px;">
                                    <span style="color: gray;">考试类型</span>
                                    <span style="float: right;">三力测试</span>
                                </div>
                                <div style="width: 100%;font-size: 20px;">
                                    <span style="color: gray;">考试标准</span>
                                    <span style="float: right;">20题，20分钟</span>
                                </div>
                                <div style="width: 100%;font-size: 20px;">
                                    <span style="color: gray;">合格标准</span>
                                    <span style="float: right;">90分及格 (满分100分)</span>
                                </div>
                                <div style="width: 100%;font-size: 20px;">
                                    <span style="color: gray;">出题规则</span>
                                    <span style="float: right;">根据公安部出题规则组卷</span>
                                </div>
                                <div
                                    style="width: 100%;border-radius: 8px;background-color: #f6f5fa;color: #6f6f71;font-size: 14px;padding: 10px;line-height: 1.5;">
                                    计分规则：考试模式不能修改答案，每错1题扣5分，错题累计超过2道，考试不能通过，系统自动提醒交卷。
                                </div>
                            </div>
                        </div>
                        <div
                            style="width: 100%;height: 80px;display: flex;align-items: center;justify-content: center;">
                            <yButton @click="handleClick(2)" border-radius="200px" mask-color="white" color="white"
                                background-color="#5385f6" font-size="22px" padding="16px 110px">
                                开始考试</yButton>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, defineProps, computed, watch, onMounted, onBeforeUnmount } from 'vue'
import store from '../module/store'
import tool from '../module/tool'
import yButton from './yButton.vue';
import images from '@/assets/images';

const config = ref({
    show: 0,
    title: '1 > 1 > 1 > 1',
    async control(op) {
        if (op) {
            this.show = 1
            await tool.wait(0.001)
            this.show = 2
        } else {
            this.show = 1
            await tool.wait(0.2)
            this.show = 0
        }
    }
})

const handleClick = async (index) => {
    let re = await tool.requestData(index==2 ? '/student/san_li_simulation_exam' : '/student/get_san_li_list', {})
    if (re.status == 0) {
        tool.controlWarningForm(true, re.content)
        return
    }
    if (re.data.length == 0) {
        tool.controlWarningForm(true, '题目列表为空')
        return
    }
    config.value.control(false)
    if (index == 1) {
        tool.handleShowTSE('三力测试', 'practice', undefined, 0, re.data)
    } else {
        tool.handleShowTSE('三力测试', 'exam', undefined, 1, re.data)
    }
}

const zoom = ref(tool.pageZoom())

onMounted(async () => {
    store.onChange('controlSanLiStartForm', () => {
        let data = store.getItem('controlSanLiStartForm')
        config.value.title = data.title
        config.value.control(data.op)
    })

    tool.watchResize('fullWindow', () => {
        zoom.value = tool.pageZoom()
    })
})
</script>

<style scoped></style>